import type { BaseRuntimeConfig } from '@blufin/web';
import { NextJsReactEnvironmentClientAlpha } from '@blufin/web';
import type { ReactNode } from 'react';
import React, { useRef } from 'react';
import { EnvironmentContextAlpha } from '../EnvironmentClientAlpha/EnvironmentContextAlpha';

export interface NextJsEnvironmentProviderAlphaProps<TCustom extends object = {}> {
  children: ReactNode;
  runtimeConfig: BaseRuntimeConfig<TCustom>;
  version?: string;
}

/**
 * Environment provider for Next.js sites.
 * Provides the same EnvironmentContextAlpha context as EnvironmentProviderAlpha,
 * enabling useEnvironmentAlpha() to work unchanged.
 * @param root0 - Component props.
 * @param root0.runtimeConfig - The runtime configuration parsed from NEXT_PUBLIC_APP_CONFIG.
 * @param root0.version - Optional app version string.
 * @param root0.children - React child elements to be wrapped by the provider.
 */
export const NextJsEnvironmentProviderAlpha: React.FC<NextJsEnvironmentProviderAlphaProps> = ({
  runtimeConfig,
  version,
  children
}) => {
  const environmentClientRef = useRef<NextJsReactEnvironmentClientAlpha | null>(null);
  if (!environmentClientRef.current)
    environmentClientRef.current = new NextJsReactEnvironmentClientAlpha(runtimeConfig, version);
  return (
    <EnvironmentContextAlpha.Provider value={environmentClientRef.current}>{children}</EnvironmentContextAlpha.Provider>
  );
};
